/**
 * Driver certificate enums — cross-stack (#1623).
 *
 * Single source for backend entity + web UI. The DB column is
 * varchar(30), so adding values here needs no migration. Comments follow
 * Turkish regulation (plan risk R9: SRC5 is the ADR dangerous-goods
 * certificate, NOT SRC3).
 */

export enum CertificateType {
  // US
  CDL_A = 'CDL_A',
  CDL_B = 'CDL_B',
  CDL_C = 'CDL_C',
  HAZMAT = 'HAZMAT',
  TWIC = 'TWIC',
  MEDICAL_CARD = 'MEDICAL_CARD',

  // TR
  SRC1 = 'SRC1', // Uluslararasi yolcu (international passenger)
  SRC2 = 'SRC2', // Yurtici yolcu (domestic passenger)
  SRC3 = 'SRC3', // Uluslararasi esya/kargo (international freight)
  SRC4 = 'SRC4', // Yurtici esya/kargo (domestic freight)
  SRC5 = 'SRC5', // ADR tehlikeli madde (dangerous goods)
  PSIKOTEKNIK = 'PSIKOTEKNIK',
  SAGLIK_RAPORU = 'SAGLIK_RAPORU',

  // Dangerous-goods class-specific trainings (DG Phase 2)
  ADR_CLASS_1_TRAINING = 'ADR_CLASS_1_TRAINING', // explosives
  ADR_CLASS_7_TRAINING = 'ADR_CLASS_7_TRAINING', // radioactive
  ADR_TANK_TRAINING = 'ADR_TANK_TRAINING', // tank carriage
}

export enum CertificateStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  SUSPENDED = 'SUSPENDED',
  REVOKED = 'REVOKED',
}

/** Types whose rows may carry the `metadata.adrClasses` convention (DG-10). */
export const DG_ADR_CLASS_CERTIFICATE_TYPES: readonly CertificateType[] = [
  CertificateType.SRC5,
  CertificateType.HAZMAT,
  CertificateType.ADR_CLASS_1_TRAINING,
  CertificateType.ADR_CLASS_7_TRAINING,
  CertificateType.ADR_TANK_TRAINING,
];
